import React from 'react';
import './App.css';
import Home from './screens/login/index';
import Register from './screens/menu/qr/qrRegister/index';
import IngresoQR from './screens/menu/qr/qrReader/index';
import TicketGenerated from './screens/menu/list/eventList/index';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Ticket from './screens/menu/qr/qrTicket/index';
import Tablero from './screens/menu/board/index';
import Dashboard from './screens/menu/reports/index';
import List from './screens/menu/list/visitList/index';
import Planta from './screens/menu/administration/sites/index';
import CategoriaProducto from './screens/menu/administration/productCategory/index';
import Balanzas from './screens/menu/administration/scales/index';
import Productos from './screens/menu/administration/product/index';
import Configuration from './screens/menu/configuration/index';
import ListHistoric from './screens/menu/list/historicList/index';
import ScaleModel from './screens/menu/administration/scaleModel/index';
import ScaleBrand from 'screens/menu/administration/scaleBrand';
import PwaInstallBar from './components/layout/pwa/index';
import { AuthProvider } from './components/authentication/Auth';
import ProtectedRoute from './components/authentication/protectedRoute';
import Auth from 'components/authentication/authToken';

function App() {
  return (
    <AuthProvider>
      <Router>
        <PwaInstallBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth-microsoft" element={<Auth />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/registro-ticket" element={<Register />} />
            <Route path="/ingresoQR" element={<IngresoQR />} />
            <Route path="/detalle-ticket" element={<Ticket />} />
            <Route path="/tablero" element={<Tablero />} />
            <Route path="/reportes" element={<Dashboard />} />
            <Route path="/lista" element={<List />} />
            <Route path="/plantas" element={<Planta />} />
            <Route path="/balanzas" element={<Balanzas />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/configuracion" element={<Configuration />} />
            <Route path="/tickets-generados" element={<TicketGenerated />} />
            <Route path="/historico" element={<ListHistoric />} />
            <Route path="/modelo-balanzas" element={<ScaleModel />} />
            <Route path="/categoria-productos" element={<CategoriaProducto />} />
            <Route path="/marca-balanzas" element={<ScaleBrand />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;